import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";

import { getPagePath, PAGES } from "@/config/pages";
import { isSupportedLanguage } from "@/i18n/routing";
import { useVolunteerAuthStore } from "@/stores/VolunteerAuthStore";

const VolunteerProtectedRoute = () => {
  const location = useLocation();
  const { lang } = useParams<{ lang?: string }>();
  const { isAuthenticated } = useVolunteerAuthStore();

  const loginPath = isSupportedLanguage(lang)
    ? getPagePath("volunteerLogin", lang)
    : PAGES.volunteerLogin;

  if (!isAuthenticated) {
    return <Navigate to={loginPath} replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default VolunteerProtectedRoute;
